import { Outlet } from "@tanstack/react-router";
import { Suspense } from "react";
import { ReactComponent as Mesh } from "assets/img/social/mesh.svg";
import { LatestArticlesSidebar } from "components/layout/LatestArticlesSidebar";
import { LoadingOverlay } from "components/layout/LoadingOverlay";
import { NewsSidebar } from "components/layout/NewsSidebar";
import { TrendingSidebar } from "components/layout/TrendingSidebar";
import { useCurrentUser } from "hooks/useCurrentUser";

export const SocialLayout = () => {
    const currentUser = useCurrentUser();
    return (
        <div className="mx-auto w-full justify-center">
            <div className="grid grid-cols-12 gap-6">
                {/* Conversations Section */}
                <div className="col-span-12 pt-6 pb-8 xl:col-span-8">
                    <div className="relative mb-7 flex w-full max-w-full items-center rounded-2xl">
                        {/* SVG Mesh Background */}
                        <Mesh
                            className="absolute inset-0 h-full w-full rounded-2xl"
                            preserveAspectRatio="none"
                        />

                        <div className="relative z-10 w-full max-w-screen-md px-8 py-8">
                            <h2 className="mb-4 font-sans text-[20px] font-normal leading-[24px] text-[#424242]">
                                👋 <span>Hi, {currentUser?.name}</span>!
                            </h2>
                            <div className="mb-4 font-sans text-[25px] font-semibold leading-[30px] text-[#424242]">
                                Welcome to the Social Portal
                            </div>
                            <p className="font-sans text-base font-normal leading-tight text-[#424242]">
                                Stay updated with the community, articles and more.
                            </p>
                        </div>
                    </div>

                    {/*<div className="mx-6 mb-3">Conversations</div>*/}
                    <div className="mx-auto flex w-full flex-col gap-6">
                        <Suspense fallback={<LoadingOverlay />}>
                            <Outlet />
                        </Suspense>
                    </div>
                </div>

                {/* News Section */}
                <div className="__sticky top-6 col-span-4 hidden h-[calc(100vh-theme(space.14))] flex-col pt-6 pb-8 xl:flex">
                    <Suspense fallback={<LoadingOverlay />}>
                        <TrendingSidebar filterType="post" title="Trending Posts" limit={20} />
                        <LatestArticlesSidebar />
                        <NewsSidebar />
                    </Suspense>
                </div>
            </div>
        </div>
    );
};
